var map = {
	"./Marine.png": 98,
	"./Mr_Raj.jpg": 875,
	"./Taas Logo.png": 684,
	"./chooseus.jpg": 459,
	"./compressor.jpg": 267,
	"./generator-repair.jpg": 931,
	"./heresite-coating.jpg": 403,
	"./lathe work.jpg": 777,
	"./lathe-works.jpg": 793,
	"./mechanical-seals.jpg": 128,
	"./motor-rewinding.jpg": 281,
	"./placeholderImage.jpg": 782,
	"./service1.jpg": 382,
	"./service2.jpg": 534,
	"./service3.jpg": 628,
	"./service4.jpg": 591,
	"./service5.jpg": 594,
	"./service6.jpg": 733,
	"./service7.jpg": 280,
	"./team.jpg": 803,
	"./videoframe.jpg": 720,
	"./water-pump.jpg": 532
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 644;